// src/components/NavTestbedSwitcher.jsx
import React from 'react';
import { Select,} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setTestbed, selectTestbed } from '../slices/testbedSlice';

const OPTIONS = [
  { value: 'tbA', label: 'INTRA' },
  { value: 'tbB', label: 'TMA' },
];

export default function NavTestbedSwitcher({ isAdmin }) {
  const dispatch = useDispatch();
  const tbId = useSelector(selectTestbed);
  if (!isAdmin) return null;

  const onChange = (v) => {
    dispatch(setTestbed(v));
    // hard reload to rebuild sockets, caches, derived URLs, etc.
    window.location.reload();
  };

  return (
    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
      <p  style={{ margin:0 }}>
        choose testbed :
      </p>
      <Select
        size="small"
        style={{ width: 200 }}
        value={tbId || undefined}
        options={OPTIONS}
        onChange={onChange}
        placeholder="Select testbed"
      />
    </div>
  );
}
